import { gql } from "@apollo/client";
import { BUSINESS_BOOKING_TYPE_FIELDS } from "./bookingType";

export const BUSINESS_FIELDS_FRAGMENT = `
  id
  name
  displayOnBookingPage
  description
  businessCategoryId
  images {
    id
    url
    businessId
    staffId
  }
  status
  currency
  street
  countryId
  stateId
  cityId
  address
  zipcode 
  stage
  createdBy
  roles {
    id
    name
    description
    permissions
  }
  plans {
    id
    name
    priceMonthly
    priceYearly
    features
  }
  phoneNumbers {
    countryCode
    phoneNumber
  }
  emails
  url
  links {
    platform
    url
  } 
  workingHourGroups {
    id
    title
    def
    custom
    isForBusiness
    timeZone {
    id
    timezone
    }
    workingHours {
      id
      groupId
      day
      onJob
      startTime
      endTime
      parentId
    }
  } 
  businessBookingTypes {      
      ${BUSINESS_BOOKING_TYPE_FIELDS}
    } 
  staffs {
    status 
    id
    url
    showGoogleEvents
    image {
      id
      url
      staffId
    }
    subscription
    {
      id
      planId 
    }
    workingHourGroups {
      id
      title
      def
      custom
      isForBusiness
      timeZone {
          id
          timezone
        }
      workingHours {
        id
        groupId
        day
        onJob
        startTime
        endTime
        parentId
      }
      workingHourOverrideGroups {
        id
        groupId
        startDate
        endDate
        title
        workingHourOverrides {
          id
          whOverrideGroupId
          startTime
          endTime
        }
      }
      
    } 
    user {
      id
      email
      username
       timeZone {
        id,
        timezone
        }
    }
    role
    {
      id
      name
      permissions
    }
  }
`;

// Define the query using the fragment
export const GET_MY_BUSINESSES = gql`
  query MyBusinesses {
    myBusinesses {    
      ${BUSINESS_FIELDS_FRAGMENT}
    }
  }
`;

// You can define another query with a different name using the same fragment
export const GET_BUSINESSES = gql`
query GetBusinesses($countryId: ID) {
  businesses(countryId: $countryId) { 
    ${BUSINESS_FIELDS_FRAGMENT}
  }
}
`;

export const GET_BUSINESS_AND_RELATED_BY_ID = gql`
query GetBusinessById($id: ID, $staffUrl: String) {
  business(id: $id, staffUrl: $staffUrl) { 
    ${BUSINESS_FIELDS_FRAGMENT}
  }
}
`;

export const GET_BUSINESS_BY_URL = gql`
query GetBusinessByUrl($businessUrl: String, $staffUrl: String) {
  businessByUrl(businessUrl: $businessUrl, staffUrl: $staffUrl) { 
    ${BUSINESS_FIELDS_FRAGMENT}
  }
}
`;

// Define the enum for query names
export enum BusinessQueryNames {
  GET_MY_BUSINESSES = "GET_MY_BUSINESSES",
  GET_BUSINESSES = "GET_BUSINESSES",
}
